<template>
  <div class="newsletter">
    <vue-headful
    title="Newsletter - Alabama.Travel"
    description="Newsletter ."
    url="https://alabama.travel/newsletter"/>
      <div>
        <picture>
          <source
            media="(max-width: 768px)"
            srcset="../../public/images/banner/sweet-spot-header/sweet-spot-header.png 1x, ../../public/images/banner/sweet-spot-header/sweet-spot-header@2x.png 2x,
                ../../public/images/banner/sweet-spot-header/sweet-spot-header@3x.png 3x"
          >
          <img src="../../public/images/banner/sweet-spot-header/sweet-spot-header-copy.png" srcset="../../public/images/banner/sweet-spot-header/sweet-spot-header-copy@2x.png 2x,
            ../../public/images/banner/sweet-spot-header/sweet-spot-header-copy@3x.png 3x" class="sweet-spot-header img-fluid">
          <img src="../../public/images/logos/atoms-logos-sweet-spot/atoms-logos-sweet-spot.png"
          srcset="../../public/images/logos/atoms-logos-sweet-spot/atoms-logos-sweet-spot@2x.png 2x,
                  ../../public/images/logos/atoms-logos-sweet-spot/atoms-logos-sweet-spot@3x.png 3x"
          class="atoms-logos-sweet-spot">
        </picture>
      </div>
    <div class="container">
      <div class="d-flex flex-row">
        <div class="wrapper">
          <!-- Start Here -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'newsletter',
  data() {
    return {
      visitors: {
        userId: 123,
        name: {
          firstName: '',
          lastName: '',
        },
        email: '',
        imageUrl: '',
      },
    };
  },
  methods: {
    async getVisitorsInfo() {
      const response = await axios.get(`${process.env.VUE_APP_API2}visitors/${this.visitors.userId}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      });
      this.visitors.name.firstName = response.data.firstName;
      this.visitors.name.lastName = response.data.lastName;
      this.visitors.email = response.data.email;
      this.visitors.imageUrl = response.data.imageUrl;
    },
  },
  created() {
    this.getVisitorsInfo();
  },
};
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  img.sweet-spot-header {
    width: 100vw;
    height: auto;
  }
  img.atoms-logos-sweet-spot {
    position: absolute;
    left: 59%;
    width: 9%;
    height: 15%;
    margin: 7% 0;
    object-fit: contain;
    z-index: 1;
  }
  .container {
    text-align: start;
    width: 800px;
  }
  .wrapper {
    display: grid;
    width: 100%;
    height: auto;
    justify-content: start;
    grid-template-areas: "profile-picture ."
                         "name ."
                         "email ."
                         "trips-header ."
                         "create-a-trip ."
                         "manage-header ."
                         "review newsletter"
                         "vacation-guide edit-profile";
  }
  @media only screen and (max-width: 768px) {
  img.atoms-logos-sweet-spot {
    display: none;
  }
  .container {
    width: 100%;
  }
  .wrapper {
    display: grid;
    width: 90%;
    margin: 0 20px;
    grid-template-areas: "profile-picture"
                         "name"
                         "email"
                         "trips-header"
                         "create-a-trip"
                         "manage-header"
                         "review"
                         "newsletter"
                         "vacation-guide"
                         "edit-profile";
  }
}
</style>
